"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSpinnersCss = require("react-spinners-css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _reactBootstrap = require("react-bootstrap");

var _syngentaReactComponents = require("syngenta-react-components");

var _hooksLib = require("../../libs/hooksLib");

var _formatHelper = require("../../libs/formatHelper");

require("./ForgotPassword.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var initialState = {
  method: 'Unknown error has occured, please try again',
  showContact: true
};

function reducer(state, action) {
  switch (action.type) {
    case 'email_error':
      return {
        textDisplay: "Invalid username or password code combination, please try again",
        showContact: true
      };

    case 'phone_error':
      return {
        textDisplay: "Invalid phone or sms code combination, please try again",
        showContact: true
      };

    case 'incomplete_login':
      return {
        textDisplay: 'Please provide a valid email or 10 digit phone number',
        showContact: false
      };

    case 'sms_resend':
      return {
        textDisplay: 'New SMS code sent',
        showContact: false
      };

    default:
      throw new Error();
  }
}

var ForgotPassword = function ForgotPassword(_ref) {
  var APP_CLIENT_ID = _ref.APP_CLIENT_ID,
      COGNITO_DOMAIN = _ref.COGNITO_DOMAIN,
      COGNITO_SIGNIN_CALLBACK = _ref.COGNITO_SIGNIN_CALLBACK,
      COGNITO_SIGNOUT_CALLBACK = _ref.COGNITO_SIGNOUT_CALLBACK,
      containerClasses = _ref.containerClasses,
      propsIsLoading = _ref.propsIsLoading,
      verificationCodeLength = _ref.verificationCodeLength,
      backToLoginPath = _ref.backToLoginPath,
      IDENTITY_POOL_ID = _ref.IDENTITY_POOL_ID,
      logoPath = _ref.logoPath,
      REGION = _ref.REGION,
      USER_POOL_ID = _ref.USER_POOL_ID,
      responseType = _ref.responseType,
      scope = _ref.scope;

  var _useState = (0, _react.useState)(propsIsLoading || false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useFormFields = (0, _hooksLib.useFormFields)({
    forgotPasswordEmail: '',
    code: '',
    newPassword: '',
    confirmNewPassword: ''
  }),
      _useFormFields2 = _slicedToArray(_useFormFields, 2),
      fields = _useFormFields2[0],
      handleFieldChange = _useFormFields2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)('init'),
      _useState6 = _slicedToArray(_useState5, 2),
      view = _useState6[0],
      setView = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      session = _useState8[0],
      setSession = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showModal = _useState10[0],
      setShowModal = _useState10[1];

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  _awsAmplify["default"].configure({
    Auth: {
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      region: REGION,
      userPoolId: USER_POOL_ID,
      identityPoolId: IDENTITY_POOL_ID,
      userPoolWebClientId: APP_CLIENT_ID,
      oauth: {
        domain: COGNITO_DOMAIN,
        scope: scope ? scope : ['phone', 'email', 'profile', 'openid'],
        redirectSignIn: COGNITO_SIGNIN_CALLBACK,
        redirectSignOut: COGNITO_SIGNOUT_CALLBACK,
        responseType: responseType || 'code'
      }
    }
  });

  var className = 'Login';
  if (containerClasses) className += " ".concat(containerClasses);

  var validateForm = function validateForm() {
    switch (view) {
      case 'init':
        return fields.forgotPasswordEmail.length > 0 && (0, _formatHelper.isValidEmail)(fields.forgotPasswordEmail);

      case 'newPassword':
        return fields.code.length === (verificationCodeLength || 6) && fields.newPassword.length > 0 && fields.newPassword === fields.confirmNewPassword;

      case 'success':
      case 'error':
      default:
        return true;
    }
  };

  var handleReset = function handleReset() {
    setIsLoading(true);
    handleFieldChange({
      reset: true
    });
    setView('init');
    setIsLoading(false);
  };

  var handleSubmit = function handleSubmit(e) {
    if (e) e.preventDefault();

    switch (view) {
      case 'init':
        setIsLoading(true);

        _awsAmplify.Auth.forgotPassword(fields.forgotPasswordEmail).then(function (data) {
          setView('newPassword');
          setIsLoading(false);
        })["catch"](function (err) {
          console.error(err);
          setView('error');
          setError(err.message ? err.message : 'Unknown error has occured, please try again');
          setIsLoading(false);
        });

        break;

      case 'newPassword':
        setIsLoading(true);

        _awsAmplify.Auth.forgotPasswordSubmit(fields.forgotPasswordEmail, fields.code, fields.newPassword).then(function (data) {
          setView('success');
          setIsLoading(false);
        })["catch"](function (err) {
          console.error(err);
          setView('error');
          setError(err.message ? err.message : 'Unknown error has occured, please try again');
          setIsLoading(false);
        });

        break;

      case 'success':
        window.location = backToLoginPath || '/login';

      case 'error':
        handleReset();

      default:
        break;
    }
  };

  var buttonText = function buttonText() {
    switch (view) {
      case 'success':
        return 'Finish';

      case 'error':
        return 'Try Again';

      default:
      case 'init':
      case 'newPassword':
        return 'Next';
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb75"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logoPath,
    alt: "company logo"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fw600 fz17 df mb20"
  }, view !== 'newPassword' ? /*#__PURE__*/_react["default"].createElement("span", null, "Forgot Password") : /*#__PURE__*/_react["default"].createElement("span", null, "We Sent A Code To Your Email")), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, view === 'init' && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "forgotPasswordEmail",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Email")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: "text",
    placeholder: "Enter Email",
    value: fields.forgotPasswordEmail,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  })), view === 'newPassword' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "code",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Verification Code")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: "text",
    placeholder: "Check your email or SMS",
    value: fields.code,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "newPassword",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "New Password")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: "password",
    placeholder: "",
    value: fields.newPassword,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "confirmNewPassword",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Confirm New Password")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: "password",
    placeholder: "",
    value: fields.confirmNewPassword,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  }))), view === 'success' && /*#__PURE__*/_react["default"].createElement("span", null, "Success"), view === 'error' && /*#__PURE__*/_react["default"].createElement("span", null, "Error: ", error), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w100% mt35 mb15"
  }, /*#__PURE__*/_react["default"].createElement(_syngentaReactComponents.LoaderButton, {
    customClassName: "custom-button syngenta-green w320 mt15",
    clickHandler: handleSubmit,
    disabled: !validateForm() || isLoading
  }, /*#__PURE__*/_react["default"].createElement("div", null, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactSpinnersCss.Ring, {
    color: "white",
    size: 20
  }) : buttonText())))));
};

ForgotPassword.propTypes = {
  APP_CLIENT_ID: _propTypes["default"].string.isRequired,
  COGNITO_DOMAIN: _propTypes["default"].string.isRequired,
  COGNITO_SIGNIN_CALLBACK: _propTypes["default"].string.isRequired,
  COGNITO_SIGNOUT_CALLBACK: _propTypes["default"].string.isRequired,
  REGION: _propTypes["default"].string.isRequired,
  USER_POOL_ID: _propTypes["default"].string.isRequired,
  IDENTITY_POOL_ID: _propTypes["default"].string.isRequired,
  propsIsLoading: _propTypes["default"].bool,
  containerClasses: _propTypes["default"].string,
  verificationCodeLength: _propTypes["default"].number,
  backToLoginPath: _propTypes["default"].string,
  logoPath: _propTypes["default"].string,
  scope: _propTypes["default"].array
};
var _default = ForgotPassword;
exports["default"] = _default;